<template>
    <div style="width: 100%;height: 100%">
        <Card dis-hover style="min-height: 100%;">
            <Row type="flex" style="padding: 0 20px" justify="center">
                <Col span="24">
                    <Form :label-width="100">
                        <FormItem label="饮食原则：">
                            <Select transfer multiple v-model.sync="dietGuidelines" placeholder="请选择" @on-change="getFoodsByDietGuidline">
                                <Option v-for="item in dietGuidelinesAllList" :value="item.id" :key="item.id">
                                    {{ item.name }}
                                </Option>
                            </Select>
                        </FormItem>
                    </Form>
                    <Collapse v-if="dietGuidelines.length > 0 " v-model="panelValue">
                        <Form :label-width="100" style="margin-top: 10px">
                            <Row>
                                <Col span="12">
                                <FormItem label="食材：">
                                    <Input v-model="foodMaterial" placeholder="请输入" clearable prefix="ios-search" @on-enter="getFoodsByDietGuidline"/>
                                </FormItem>
                                </Col>
                                <Col span="12" style="display: flex;flex-direction: row;justify-content: flex-end">
                                    <Button type="info" icon="ios-search" @click="getFoodsByDietGuidline">查询</Button>
                                </Col>
                            </Row>
                        </Form>
                    <Panel>
                    可食用食材
                        <p slot="content">
                            <Table stripe max-height="350" :columns="dietGuidelinesColumns" :data="edibalFoodList"></Table>
                        </p>
                    </Panel>
                        <Panel >
                            不建议食用食材
                            <p slot="content">
                                <Table stripe max-height="350" :columns="dietGuidelinesColumns" :data="inedibleFood"></Table>
                            </p>
                        </Panel>
                    </Collapse>
                </Col>
            </Row>
        </Card>
        <Modal v-model="infoModel" title="食材详情" width="600" @on-cancel="cancelItem">
            <Form :label-width="100">
                <Row v-if="infoItem != null">
                    <Col span="12">
                    <FormItem label="食材名称：">
                        {{infoItem.name}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="食材单位：">
                        {{infoItem.unit}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="食材类别：">
                        {{infoItem.foodMaterialType.name}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="升糖指数(GI)：">
                        {{infoItem.gi}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="血糖负荷(GL)：">
                        {{infoItem.gl}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="食材品牌：">
                        {{infoItem.brand}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="食材产地：">
                        {{infoItem.origin}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="食材品种：">
                        {{infoItem.variety}}
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <Form label-position="top">
                <FormItem label="营养物质：" v-if="infoItem != null">
                    <Table stripe max-height="250" :columns="columnsInfo" :data="infoItem.nutritionTypeList"></Table>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: "dietGuidlineFood",
        data() {
            return {
                infoItem: null,
                infoModel: false,
                dietGuidelinesAllList: [
                    {
                        id: 1,
                        name: '饮食原则1'
                    },
                    {
                        id: 2,
                        name: '饮食原则2'
                    }
                ],//所有原则
                dietGuidelines: [],
                dietGuidelinesColumns: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '食材',
                        align: 'center',
                        key: 'foodMaterialName',
                        ellipsis: true,
                        tooltip: true
                    },
                    {
                        title: '详情',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon: 'ios-list-box',
                                        label: "small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.infoItem_modal(params.row)
                                        }
                                    }
                                }, '详情'),
                            ])
                        }
                    }
                ],//食材表头
                columnsInfo: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '营养物质',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let item = this.infoItem.nutritionTypeList[params.index]
                            return h("span", item.name + '（' + item.forShort + '） - ' + item.englishName)
                        },
                    },
                    {
                        title: '含量',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let item = this.infoItem.nutritionTypeList[params.index]
                            return h("span", item.value + ' ' + item.unit)
                        },
                    },
                    {
                        title: '重点营养物质',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let item = this.infoItem.nutritionTypeList[params.index]
                            return h("span", item.isKey ? '是' : '')
                        },
                    },
                ],
                foodMaterial: '',
                edibalFoodList: [],
                inedibleFood: [],
                panelValue: [1, 2]
            }
        },
        created() {
            this.findAllDietGuidelinesList()
        },
        methods: {
            // 获取饮食原则
            findAllDietGuidelinesList() {
                this.$http.post('dietGuidelines/list', {
                    isDeleted: false,
                    pageSize: 0,
                    pageNum: 0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.dietGuidelinesAllList = msg.data
                    } else {
                        this.$Notice.error({title: '饮食原则查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            },
            getFoodsByDietGuidline () {
                if (this.dietGuidelines == null || this.dietGuidelines.length <= 0) {
                    return
                }
                console.log('guidelines', this.dietGuidelines)
                this.$http.post('drools/getFood',
                    {
                        ids: JSON.stringify(this.dietGuidelines),
                        foodMaterialName: this.foodMaterial
                    }
                ).then(function (res) {
                    let msg = res.body
                    console.log('msg_____', msg)
                    if (msg.success) {
                        if (msg.data != null) {
                            this.edibalFoodList = msg.data.edibalFoodList
                            this.inedibleFood = msg.data.inedible
                        }
                    } else {
                        this.$Notice.error({title: '查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            },
            getFoodMaterialDetails (foodId) {
                this.$http.post('foodMaterial/detail2',
                    {
                        foodMaterialId: foodId
                    }
                ).then(function (res) {
                    let msg = res.body
                    console.log('msg_____', msg)
                    if (msg.success) {
                        this.infoItem = msg.data
                    } else {
                        this.$Notice.error({title: '获取详情失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            },
            infoItem_modal(item) {
                this.getFoodMaterialDetails(item.foodMaterialId)
                this.infoModel = true
            },
            cancelItem() {
                this.infoModel = false
            }
        }
    }
</script>

<style scoped>

</style>